import {BaseClient} from '../utils/base-client';

class ABMessageVariantsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    const workspaceOrProject = workspaceId ? `workspaces/${workspaceId}` : `projects/${projectId}`;
    return `api/app/${workspaceOrProject}/messages/ab-variants/`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const abMessageVariantsClient = new ABMessageVariantsClient();
